<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Edición ítem</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Edición ítem</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="ncItemForm">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NroLinea}}</mat-label>

                        <input readonly formControlName="nroLinea" type="text" matInput>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.CantidadDevolucion}}</mat-label>
                        <input appThreeDigitDecimaNumber formControlName="cantidadDevolucion" type="text" matInput>
                        <mat-error
                            *ngIf=" !ncItemForm.controls['cantidadDevolucion'].valid && ncItemForm.get('cantidadDevolucion').touched">
                            {{Validaciones.CantidadDevolucion}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" *ngIf="avisoUnidadesPallet">

                    <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                        <mat-card-content>

                            <p>{{this.mensajeUnidadesPallet}} </p>

                        </mat-card-content>

                    </mat-card>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.CantidadVendida}}</mat-label>
                        <input readonly [value]=" ncItemForm.controls['cantidadVendida'].value | number:'':'es-AR'"
                            type="text" matInput>

                    </mat-form-field>
                </div>



                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                        <input readonly formControlName="idProducto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Producto}}</mat-label>
                        <input readonly formControlName="producto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="ncCab != null && ncCab.idTipoNC == '1'" class="readonly-form-field"
                        color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioVenta}}</mat-label>
                        <input readonly [value]="ncItemForm.get('precioVenta').value | number : '1.2-2'" type="text"
                            matInput>
                    </mat-form-field>
                    <mat-form-field *ngIf="ncCab != null && ncCab.idTipoNC != '1'" color="accent-darker"
                        appearance="outline">
                        <mat-label>{{Etiquetas.PrecioVenta}}</mat-label>
                        <input appTwoDigitDecimaNumber type="text" matInput formControlName="precioVenta">
                        <mat-error
                            *ngIf="!ncItemForm.controls['precioVenta'].valid && ncItemForm.get('precioVenta').touched">
                            {{Validaciones.PrecioVenta}}
                        </mat-error>
                    </mat-form-field>

                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Comentario}}</mat-label>

                        <textarea #comentarioItem matInput maxlength="1024" formControlName="comentario"
                            type="text"></textarea>
                        <mat-hint align="start">Máximo: 1024
                            caracteres</mat-hint>
                        <mat-hint align="end">{{comentarioItem.value?.length
                            || 0}} / 1024</mat-hint>

                    </mat-form-field>

                </div>




            </div>
        </div>




    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarItem()" [disabled]="ncItemForm.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>